export default "__VITE_ASSET__BCx$9tIK__"